const isLoggingEnabled = () => {
  const dev = import.meta.env.DEV ?? false;
  const salesFlowDebug = import.meta.env.VITE_SALES_FLOW_DEBUG ?? "";

  return dev || salesFlowDebug === "true";
};

const formatLogMessage = (source, marker, message, suffix) => {
  const base = `[Venda:${source}] ${marker} ${message}`;
  if (!suffix) return base;

  return `${base} ${suffix}`;
};

const formatContext = (context = {}) =>
  Object.entries(context)
    .filter(([, value]) => value != null && value !== "")
    .map(([key, value]) => `${key}=${value}`)
    .join(" ");

export const salesFlowStart = (source, message, context = {}) => {
  if (!isLoggingEnabled()) return;

  const suffix = formatContext(context);
  console.info(formatLogMessage(source, "▶", message, suffix));
};

export const salesFlowConfirm = (source, message, context = {}) => {
  if (!isLoggingEnabled()) return;

  const suffix = formatContext(context);
  console.info(formatLogMessage(source, "✓", message, suffix));
};

export const salesFlowDebug = (source, message) => {
  if (!isLoggingEnabled()) return;

  console.debug(`[Venda:${source}] ${message}`);
};

export const salesFlowError = (source, message, error) => {
  if (!isLoggingEnabled()) return;

  const detail = error?.message || error;
  console.error(`[Venda:${source}] ✗ ${message}`, detail);
};
